export const GET_RESULTS__REQUEST = 'RESULT_TYPE__GET_RESULTS__REQUEST';
export const GET_RESULTS__SUCCESS = 'RESULT_TYPE__GET_RESULTS__SUCCESS';
export const GET_RESULTS__FAILURE = 'RESULT_TYPE__GET_RESULTS__FAILURE';
